import { render, staticRenderFns } from "./CustomModalNotify.vue?vue&type=template&id=4920a783&"
import script from "./CustomModalNotify.vue?vue&type=script&lang=js&"
export * from "./CustomModalNotify.vue?vue&type=script&lang=js&"
import style0 from "./CustomModalNotify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports